var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 761,
    height: 296,
    viewBox: "0 0 761 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    clipPath: "url(#clip0_664_32116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.913 8.02317C271.913 7.05763 271.131 6.2749 270.165 6.2749C269.199 6.2749 268.417 7.05763 268.417 8.02317V11.5197C268.417 12.4853 269.199 13.268 270.165 13.268C271.131 13.268 271.913 12.4853 271.913 11.5197V8.02317Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 35.9956C271.914 35.03 271.131 34.2473 270.165 34.2473C269.2 34.2473 268.417 35.03 268.417 35.9956V39.4921C268.417 40.4577 269.2 41.2404 270.165 41.2404C271.131 41.2404 271.914 40.4577 271.914 39.4921V35.9956Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 63.9685C271.914 63.0029 271.131 62.2202 270.165 62.2202C269.2 62.2202 268.417 63.0029 268.417 63.9685V67.465C268.417 68.4306 269.2 69.2133 270.165 69.2133C271.131 69.2133 271.914 68.4306 271.914 67.465V63.9685Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 91.9402C271.914 90.9746 271.131 90.1919 270.165 90.1919C269.2 90.1919 268.417 90.9746 268.417 91.9402V95.4367C268.417 96.4023 269.2 97.185 270.165 97.185C271.131 97.185 271.914 96.4023 271.914 95.4367V91.9402Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 119.912C271.914 118.947 271.131 118.164 270.165 118.164C269.2 118.164 268.417 118.947 268.417 119.912V123.409C268.417 124.374 269.2 125.157 270.165 125.157C271.131 125.157 271.914 124.374 271.914 123.409V119.912Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 147.885C271.914 146.919 271.131 146.137 270.165 146.137C269.2 146.137 268.417 146.919 268.417 147.885V151.382C268.417 152.347 269.2 153.13 270.165 153.13C271.131 153.13 271.914 152.347 271.914 151.382V147.885Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 175.858C271.914 174.892 271.131 174.109 270.165 174.109C269.2 174.109 268.417 174.892 268.417 175.858V179.354C268.417 180.32 269.2 181.102 270.165 181.102C271.131 181.102 271.914 180.32 271.914 179.354V175.858Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 203.829C271.914 202.864 271.131 202.081 270.165 202.081C269.2 202.081 268.417 202.864 268.417 203.829V207.326C268.417 208.291 269.2 209.074 270.165 209.074C271.131 209.074 271.914 208.291 271.914 207.326V203.829Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.914 231.802C271.914 230.836 271.131 230.054 270.165 230.054C269.2 230.054 268.417 230.836 268.417 231.802V235.299C268.417 236.264 269.2 237.047 270.165 237.047C271.131 237.047 271.914 236.264 271.914 235.299V231.802Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.844 34.2473H296.389C294.458 34.2473 292.893 35.8128 292.893 37.7439C292.893 39.6749 294.458 41.2404 296.389 41.2404H341.844C343.775 41.2404 345.341 39.6749 345.341 37.7439C345.341 35.8128 343.775 34.2473 341.844 34.2473Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.816 34.2473H359.327C357.396 34.2473 355.83 35.8128 355.83 37.7439C355.83 39.6749 357.396 41.2404 359.327 41.2404H369.816C371.747 41.2404 373.313 39.6749 373.313 37.7439C373.313 35.8128 371.747 34.2473 369.816 34.2473Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.278 34.2473H387.299C385.368 34.2473 383.802 35.8128 383.802 37.7439C383.802 39.6749 385.368 41.2404 387.299 41.2404H408.278C410.209 41.2404 411.775 39.6749 411.775 37.7439C411.775 35.8128 410.209 34.2473 408.278 34.2473Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.775 90.1919H376.81C374.878 90.1919 373.313 91.7573 373.313 93.6884C373.313 95.6195 374.878 97.185 376.81 97.185H411.775C413.706 97.185 415.271 95.6195 415.271 93.6884C415.271 91.7573 413.706 90.1919 411.775 90.1919Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.216 90.1919H429.258C427.326 90.1919 425.761 91.7573 425.761 93.6884C425.761 95.6195 427.326 97.185 429.258 97.185H471.216C473.147 97.185 474.713 95.6195 474.713 93.6884C474.713 91.7573 473.147 90.1919 471.216 90.1919Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.195 90.1919H488.699C486.768 90.1919 485.202 91.7573 485.202 93.6884C485.202 95.6195 486.768 97.185 488.699 97.185H492.195C494.127 97.185 495.692 95.6195 495.692 93.6884C495.692 91.7573 494.127 90.1919 492.195 90.1919Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.872 6.2749H296.389C294.458 6.2749 292.893 7.84036 292.893 9.77144C292.893 11.7025 294.458 13.268 296.389 13.268H313.872C315.803 13.268 317.369 11.7025 317.369 9.77144C317.369 7.84036 315.803 6.2749 313.872 6.2749Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.844 6.2749H331.355C329.424 6.2749 327.858 7.84036 327.858 9.77144C327.858 11.7025 329.424 13.268 331.355 13.268H341.844C343.775 13.268 345.341 11.7025 345.341 9.77144C345.341 7.84036 343.775 6.2749 341.844 6.2749Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.754 6.2749H359.327C357.396 6.2749 355.83 7.84036 355.83 9.77144C355.83 11.7025 357.396 13.268 359.327 13.268H432.754C434.685 13.268 436.251 11.7025 436.251 9.77144C436.251 7.84036 434.685 6.2749 432.754 6.2749Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.237 62.2202H415.271C413.34 62.2202 411.775 63.7857 411.775 65.7168C411.775 67.6478 413.34 69.2133 415.271 69.2133H450.237C452.168 69.2133 453.733 67.6478 453.733 65.7168C453.733 63.7857 452.168 62.2202 450.237 62.2202Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.699 62.2202H467.719C465.788 62.2202 464.223 63.7857 464.223 65.7168C464.223 67.6478 465.788 69.2133 467.719 69.2133H488.699C490.63 69.2133 492.195 67.6478 492.195 65.7168C492.195 63.7857 490.63 62.2202 488.699 62.2202Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.327 118.164H345.341C343.409 118.164 341.844 119.729 341.844 121.66C341.844 123.591 343.409 125.157 345.341 125.157H359.327C361.258 125.157 362.823 123.591 362.823 121.66C362.823 119.729 361.258 118.164 359.327 118.164Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.775 118.164H376.81C374.878 118.164 373.313 119.729 373.313 121.66C373.313 123.591 374.878 125.157 376.81 125.157H411.775C413.706 125.157 415.271 123.591 415.271 121.66C415.271 119.729 413.706 118.164 411.775 118.164Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.251 118.164H429.258C427.326 118.164 425.761 119.729 425.761 121.66C425.761 123.591 427.326 125.157 429.258 125.157H436.251C438.182 125.157 439.747 123.591 439.747 121.66C439.747 119.729 438.182 118.164 436.251 118.164Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.209 118.164H453.733C451.802 118.164 450.237 119.729 450.237 121.66C450.237 123.591 451.802 125.157 453.733 125.157H478.209C480.14 125.157 481.706 123.591 481.706 121.66C481.706 119.729 480.14 118.164 478.209 118.164Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.369 146.137H296.389C294.458 146.137 292.893 147.702 292.893 149.633C292.893 151.564 294.458 153.13 296.389 153.13H317.369C319.3 153.13 320.865 151.564 320.865 149.633C320.865 147.702 319.3 146.137 317.369 146.137Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.341 146.137H334.851C332.92 146.137 331.354 147.702 331.354 149.633C331.354 151.564 332.92 153.13 334.851 153.13H345.341C347.272 153.13 348.837 151.564 348.837 149.633C348.837 147.702 347.272 146.137 345.341 146.137Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.244 146.137H362.823C360.892 146.137 359.327 147.702 359.327 149.633C359.327 151.564 360.892 153.13 362.823 153.13H443.244C445.175 153.13 446.74 151.564 446.74 149.633C446.74 147.702 445.175 146.137 443.244 146.137Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.223 146.137H460.727C458.796 146.137 457.23 147.702 457.23 149.633C457.23 151.564 458.796 153.13 460.727 153.13H464.223C466.154 153.13 467.72 151.564 467.72 149.633C467.72 147.702 466.154 146.137 464.223 146.137Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.369 202.081H296.389C294.458 202.081 292.893 203.647 292.893 205.578C292.893 207.509 294.458 209.074 296.389 209.074H317.369C319.3 209.074 320.865 207.509 320.865 205.578C320.865 203.647 319.3 202.081 317.369 202.081Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81 202.081H334.851C332.92 202.081 331.354 203.647 331.354 205.578C331.354 207.509 332.92 209.074 334.851 209.074H376.81C378.741 209.074 380.306 207.509 380.306 205.578C380.306 203.647 378.741 202.081 376.81 202.081Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.782 202.081H394.292C392.361 202.081 390.795 203.647 390.795 205.578C390.795 207.509 392.361 209.074 394.292 209.074H404.782C406.713 209.074 408.278 207.509 408.278 205.578C408.278 203.647 406.713 202.081 404.782 202.081Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.733 202.081H422.265C420.334 202.081 418.768 203.647 418.768 205.578C418.768 207.509 420.334 209.074 422.265 209.074H453.733C455.665 209.074 457.23 207.509 457.23 205.578C457.23 203.647 455.665 202.081 453.733 202.081Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.327 174.109H324.361C322.43 174.109 320.865 175.675 320.865 177.606C320.865 179.537 322.43 181.102 324.361 181.102H359.327C361.258 181.102 362.823 179.537 362.823 177.606C362.823 175.675 361.258 174.109 359.327 174.109Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.789 174.109H376.81C374.878 174.109 373.313 175.675 373.313 177.606C373.313 179.537 374.878 181.102 376.81 181.102H397.789C399.72 181.102 401.285 179.537 401.285 177.606C401.285 175.675 399.72 174.109 397.789 174.109Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.23 174.109H415.271C413.34 174.109 411.775 175.675 411.775 177.606C411.775 179.537 413.34 181.102 415.271 181.102H457.23C459.161 181.102 460.726 179.537 460.726 177.606C460.726 175.675 459.161 174.109 457.23 174.109Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.209 174.109H474.713C472.782 174.109 471.216 175.675 471.216 177.606C471.216 179.537 472.782 181.102 474.713 181.102H478.209C480.14 181.102 481.706 179.537 481.706 177.606C481.706 175.675 480.14 174.109 478.209 174.109Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_32116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.309 38.5929C224.309 38.947 224.022 39.2341 223.668 39.2341C223.313 39.2341 223.026 38.947 223.026 38.5929C223.026 38.2388 223.313 37.9517 223.668 37.9517C224.022 37.9517 224.309 38.2388 224.309 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 38.5929C240.981 38.947 240.694 39.2341 240.34 39.2341C239.986 39.2341 239.699 38.947 239.699 38.5929C239.699 38.2388 239.986 37.9517 240.34 37.9517C240.694 37.9517 240.981 38.2388 240.981 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 38.5929C257.653 38.947 257.366 39.2341 257.012 39.2341C256.658 39.2341 256.371 38.947 256.371 38.5929C256.371 38.2388 256.658 37.9517 257.012 37.9517C257.366 37.9517 257.653 38.2388 257.653 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 38.5929C274.326 38.947 274.039 39.2341 273.684 39.2341C273.33 39.2341 273.043 38.947 273.043 38.5929C273.043 38.2388 273.33 37.9517 273.684 37.9517C274.039 37.9517 274.326 38.2388 274.326 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 38.5929C290.998 38.947 290.711 39.2341 290.357 39.2341C290.003 39.2341 289.716 38.947 289.716 38.5929C289.716 38.2388 290.003 37.9517 290.357 37.9517C290.711 37.9517 290.998 38.2388 290.998 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 38.5929C307.67 38.947 307.383 39.2341 307.029 39.2341C306.675 39.2341 306.388 38.947 306.388 38.5929C306.388 38.2388 306.675 37.9517 307.029 37.9517C307.383 37.9517 307.67 38.2388 307.67 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 38.5929C324.343 38.947 324.055 39.2341 323.701 39.2341C323.347 39.2341 323.06 38.947 323.06 38.5929C323.06 38.2388 323.347 37.9517 323.701 37.9517C324.055 37.9517 324.343 38.2388 324.343 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 38.5929C341.015 38.947 340.728 39.2341 340.374 39.2341C340.02 39.2341 339.732 38.947 339.732 38.5929C339.732 38.2388 340.02 37.9517 340.374 37.9517C340.728 37.9517 341.015 38.2388 341.015 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 38.5929C357.687 38.947 357.4 39.2341 357.046 39.2341C356.692 39.2341 356.405 38.947 356.405 38.5929C356.405 38.2388 356.692 37.9517 357.046 37.9517C357.4 37.9517 357.687 38.2388 357.687 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 38.5929C374.359 38.947 374.072 39.2341 373.718 39.2341C373.364 39.2341 373.077 38.947 373.077 38.5929C373.077 38.2388 373.364 37.9517 373.718 37.9517C374.072 37.9517 374.359 38.2388 374.359 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 55.265C224.309 55.6191 224.022 55.9063 223.668 55.9063C223.313 55.9063 223.026 55.6191 223.026 55.265C223.026 54.9109 223.313 54.6238 223.668 54.6238C224.022 54.6238 224.309 54.9109 224.309 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 55.265C240.981 55.6191 240.694 55.9063 240.34 55.9063C239.986 55.9063 239.699 55.6191 239.699 55.265C239.699 54.9109 239.986 54.6238 240.34 54.6238C240.694 54.6238 240.981 54.9109 240.981 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 55.265C257.653 55.6191 257.366 55.9063 257.012 55.9063C256.658 55.9063 256.371 55.6191 256.371 55.265C256.371 54.9109 256.658 54.6238 257.012 54.6238C257.366 54.6238 257.653 54.9109 257.653 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 55.265C274.326 55.6191 274.039 55.9063 273.684 55.9063C273.33 55.9063 273.043 55.6191 273.043 55.265C273.043 54.9109 273.33 54.6238 273.684 54.6238C274.039 54.6238 274.326 54.9109 274.326 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 55.265C290.998 55.6191 290.711 55.9063 290.357 55.9063C290.003 55.9063 289.716 55.6191 289.716 55.265C289.716 54.9109 290.003 54.6238 290.357 54.6238C290.711 54.6238 290.998 54.9109 290.998 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 55.265C307.67 55.6191 307.383 55.9063 307.029 55.9063C306.675 55.9063 306.388 55.6191 306.388 55.265C306.388 54.9109 306.675 54.6238 307.029 54.6238C307.383 54.6238 307.67 54.9109 307.67 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 55.265C324.343 55.6191 324.055 55.9063 323.701 55.9063C323.347 55.9063 323.06 55.6191 323.06 55.265C323.06 54.9109 323.347 54.6238 323.701 54.6238C324.055 54.6238 324.343 54.9109 324.343 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 55.265C341.015 55.6191 340.728 55.9063 340.374 55.9063C340.02 55.9063 339.732 55.6191 339.732 55.265C339.732 54.9109 340.02 54.6238 340.374 54.6238C340.728 54.6238 341.015 54.9109 341.015 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 55.265C357.687 55.6191 357.4 55.9063 357.046 55.9063C356.692 55.9063 356.405 55.6191 356.405 55.265C356.405 54.9109 356.692 54.6238 357.046 54.6238C357.4 54.6238 357.687 54.9109 357.687 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 55.265C374.359 55.6191 374.072 55.9063 373.718 55.9063C373.364 55.9063 373.077 55.6191 373.077 55.265C373.077 54.9109 373.364 54.6238 373.718 54.6238C374.072 54.6238 374.359 54.9109 374.359 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 71.9376C224.309 72.2917 224.022 72.5789 223.668 72.5789C223.313 72.5789 223.026 72.2917 223.026 71.9376C223.026 71.5835 223.313 71.2964 223.668 71.2964C224.022 71.2964 224.309 71.5835 224.309 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 71.9376C240.981 72.2917 240.694 72.5789 240.34 72.5789C239.986 72.5789 239.699 72.2917 239.699 71.9376C239.699 71.5835 239.986 71.2964 240.34 71.2964C240.694 71.2964 240.981 71.5835 240.981 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 71.9376C257.653 72.2917 257.366 72.5789 257.012 72.5789C256.658 72.5789 256.371 72.2917 256.371 71.9376C256.371 71.5835 256.658 71.2964 257.012 71.2964C257.366 71.2964 257.653 71.5835 257.653 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 71.9376C274.326 72.2917 274.039 72.5789 273.684 72.5789C273.33 72.5789 273.043 72.2917 273.043 71.9376C273.043 71.5835 273.33 71.2964 273.684 71.2964C274.039 71.2964 274.326 71.5835 274.326 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 71.9376C290.998 72.2917 290.711 72.5789 290.357 72.5789C290.003 72.5789 289.716 72.2917 289.716 71.9376C289.716 71.5835 290.003 71.2964 290.357 71.2964C290.711 71.2964 290.998 71.5835 290.998 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 71.9376C307.67 72.2917 307.383 72.5789 307.029 72.5789C306.675 72.5789 306.388 72.2917 306.388 71.9376C306.388 71.5835 306.675 71.2964 307.029 71.2964C307.383 71.2964 307.67 71.5835 307.67 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 71.9376C324.343 72.2917 324.055 72.5789 323.701 72.5789C323.347 72.5789 323.06 72.2917 323.06 71.9376C323.06 71.5835 323.347 71.2964 323.701 71.2964C324.055 71.2964 324.343 71.5835 324.343 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 71.9376C341.015 72.2917 340.728 72.5789 340.374 72.5789C340.02 72.5789 339.732 72.2917 339.732 71.9376C339.732 71.5835 340.02 71.2964 340.374 71.2964C340.728 71.2964 341.015 71.5835 341.015 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 71.9376C357.687 72.2917 357.4 72.5789 357.046 72.5789C356.692 72.5789 356.405 72.2917 356.405 71.9376C356.405 71.5835 356.692 71.2964 357.046 71.2964C357.4 71.2964 357.687 71.5835 357.687 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 71.9376C374.359 72.2917 374.072 72.5789 373.718 72.5789C373.364 72.5789 373.077 72.2917 373.077 71.9376C373.077 71.5835 373.364 71.2964 373.718 71.2964C374.072 71.2964 374.359 71.5835 374.359 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 88.6095C224.309 88.9636 224.022 89.2507 223.668 89.2507C223.313 89.2507 223.026 88.9636 223.026 88.6095C223.026 88.2554 223.313 87.9683 223.668 87.9683C224.022 87.9683 224.309 88.2554 224.309 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 88.6095C240.981 88.9636 240.694 89.2507 240.34 89.2507C239.986 89.2507 239.699 88.9636 239.699 88.6095C239.699 88.2554 239.986 87.9683 240.34 87.9683C240.694 87.9683 240.981 88.2554 240.981 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 88.6095C257.653 88.9636 257.366 89.2507 257.012 89.2507C256.658 89.2507 256.371 88.9636 256.371 88.6095C256.371 88.2554 256.658 87.9683 257.012 87.9683C257.366 87.9683 257.653 88.2554 257.653 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 88.6095C274.326 88.9636 274.039 89.2507 273.684 89.2507C273.33 89.2507 273.043 88.9636 273.043 88.6095C273.043 88.2554 273.33 87.9683 273.684 87.9683C274.039 87.9683 274.326 88.2554 274.326 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 88.6095C290.998 88.9636 290.711 89.2507 290.357 89.2507C290.003 89.2507 289.716 88.9636 289.716 88.6095C289.716 88.2554 290.003 87.9683 290.357 87.9683C290.711 87.9683 290.998 88.2554 290.998 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 88.6095C307.67 88.9636 307.383 89.2507 307.029 89.2507C306.675 89.2507 306.388 88.9636 306.388 88.6095C306.388 88.2554 306.675 87.9683 307.029 87.9683C307.383 87.9683 307.67 88.2554 307.67 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 88.6095C324.343 88.9636 324.055 89.2507 323.701 89.2507C323.347 89.2507 323.06 88.9636 323.06 88.6095C323.06 88.2554 323.347 87.9683 323.701 87.9683C324.055 87.9683 324.343 88.2554 324.343 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 88.6095C341.015 88.9636 340.728 89.2507 340.374 89.2507C340.02 89.2507 339.732 88.9636 339.732 88.6095C339.732 88.2554 340.02 87.9683 340.374 87.9683C340.728 87.9683 341.015 88.2554 341.015 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 88.6095C357.687 88.9636 357.4 89.2507 357.046 89.2507C356.692 89.2507 356.405 88.9636 356.405 88.6095C356.405 88.2554 356.692 87.9683 357.046 87.9683C357.4 87.9683 357.687 88.2554 357.687 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 88.6095C374.359 88.9636 374.072 89.2507 373.718 89.2507C373.364 89.2507 373.077 88.9636 373.077 88.6095C373.077 88.2554 373.364 87.9683 373.718 87.9683C374.072 87.9683 374.359 88.2554 374.359 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 105.282C224.309 105.636 224.022 105.923 223.668 105.923C223.313 105.923 223.026 105.636 223.026 105.282C223.026 104.928 223.313 104.641 223.668 104.641C224.022 104.641 224.309 104.928 224.309 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 105.282C240.981 105.636 240.694 105.923 240.34 105.923C239.986 105.923 239.699 105.636 239.699 105.282C239.699 104.928 239.986 104.641 240.34 104.641C240.694 104.641 240.981 104.928 240.981 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 105.282C257.653 105.636 257.366 105.923 257.012 105.923C256.658 105.923 256.371 105.636 256.371 105.282C256.371 104.928 256.658 104.641 257.012 104.641C257.366 104.641 257.653 104.928 257.653 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 105.282C274.326 105.636 274.039 105.923 273.684 105.923C273.33 105.923 273.043 105.636 273.043 105.282C273.043 104.928 273.33 104.641 273.684 104.641C274.039 104.641 274.326 104.928 274.326 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 105.282C290.998 105.636 290.711 105.923 290.357 105.923C290.003 105.923 289.716 105.636 289.716 105.282C289.716 104.928 290.003 104.641 290.357 104.641C290.711 104.641 290.998 104.928 290.998 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 105.282C307.67 105.636 307.383 105.923 307.029 105.923C306.675 105.923 306.388 105.636 306.388 105.282C306.388 104.928 306.675 104.641 307.029 104.641C307.383 104.641 307.67 104.928 307.67 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 105.282C324.343 105.636 324.055 105.923 323.701 105.923C323.347 105.923 323.06 105.636 323.06 105.282C323.06 104.928 323.347 104.641 323.701 104.641C324.055 104.641 324.343 104.928 324.343 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 105.282C341.015 105.636 340.728 105.923 340.374 105.923C340.02 105.923 339.732 105.636 339.732 105.282C339.732 104.928 340.02 104.641 340.374 104.641C340.728 104.641 341.015 104.928 341.015 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 105.282C357.687 105.636 357.4 105.923 357.046 105.923C356.692 105.923 356.405 105.636 356.405 105.282C356.405 104.928 356.692 104.641 357.046 104.641C357.4 104.641 357.687 104.928 357.687 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 105.282C374.359 105.636 374.072 105.923 373.718 105.923C373.364 105.923 373.077 105.636 373.077 105.282C373.077 104.928 373.364 104.641 373.718 104.641C374.072 104.641 374.359 104.928 374.359 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 121.954C224.309 122.309 224.022 122.596 223.668 122.596C223.313 122.596 223.026 122.309 223.026 121.954C223.026 121.6 223.313 121.313 223.668 121.313C224.022 121.313 224.309 121.6 224.309 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 121.954C240.981 122.309 240.694 122.596 240.34 122.596C239.986 122.596 239.699 122.309 239.699 121.954C239.699 121.6 239.986 121.313 240.34 121.313C240.694 121.313 240.981 121.6 240.981 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 121.954C257.653 122.309 257.366 122.596 257.012 122.596C256.658 122.596 256.371 122.309 256.371 121.954C256.371 121.6 256.658 121.313 257.012 121.313C257.366 121.313 257.653 121.6 257.653 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 121.954C274.326 122.309 274.039 122.596 273.684 122.596C273.33 122.596 273.043 122.309 273.043 121.954C273.043 121.6 273.33 121.313 273.684 121.313C274.039 121.313 274.326 121.6 274.326 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 121.954C290.998 122.309 290.711 122.596 290.357 122.596C290.003 122.596 289.716 122.309 289.716 121.954C289.716 121.6 290.003 121.313 290.357 121.313C290.711 121.313 290.998 121.6 290.998 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 121.954C307.67 122.309 307.383 122.596 307.029 122.596C306.675 122.596 306.388 122.309 306.388 121.954C306.388 121.6 306.675 121.313 307.029 121.313C307.383 121.313 307.67 121.6 307.67 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 121.954C324.343 122.309 324.055 122.596 323.701 122.596C323.347 122.596 323.06 122.309 323.06 121.954C323.06 121.6 323.347 121.313 323.701 121.313C324.055 121.313 324.343 121.6 324.343 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 121.954C341.015 122.309 340.728 122.596 340.374 122.596C340.02 122.596 339.732 122.309 339.732 121.954C339.732 121.6 340.02 121.313 340.374 121.313C340.728 121.313 341.015 121.6 341.015 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 121.954C357.687 122.309 357.4 122.596 357.046 122.596C356.692 122.596 356.405 122.309 356.405 121.954C356.405 121.6 356.692 121.313 357.046 121.313C357.4 121.313 357.687 121.6 357.687 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 121.954C374.359 122.309 374.072 122.596 373.718 122.596C373.364 122.596 373.077 122.309 373.077 121.954C373.077 121.6 373.364 121.313 373.718 121.313C374.072 121.313 374.359 121.6 374.359 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 138.627C224.309 138.981 224.022 139.268 223.668 139.268C223.313 139.268 223.026 138.981 223.026 138.627C223.026 138.273 223.313 137.986 223.668 137.986C224.022 137.986 224.309 138.273 224.309 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 138.627C240.981 138.981 240.694 139.268 240.34 139.268C239.986 139.268 239.699 138.981 239.699 138.627C239.699 138.273 239.986 137.986 240.34 137.986C240.694 137.986 240.981 138.273 240.981 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 138.627C257.653 138.981 257.366 139.268 257.012 139.268C256.658 139.268 256.371 138.981 256.371 138.627C256.371 138.273 256.658 137.986 257.012 137.986C257.366 137.986 257.653 138.273 257.653 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 138.627C274.326 138.981 274.039 139.268 273.684 139.268C273.33 139.268 273.043 138.981 273.043 138.627C273.043 138.273 273.33 137.986 273.684 137.986C274.039 137.986 274.326 138.273 274.326 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 138.627C290.998 138.981 290.711 139.268 290.357 139.268C290.003 139.268 289.716 138.981 289.716 138.627C289.716 138.273 290.003 137.986 290.357 137.986C290.711 137.986 290.998 138.273 290.998 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 138.627C307.67 138.981 307.383 139.268 307.029 139.268C306.675 139.268 306.388 138.981 306.388 138.627C306.388 138.273 306.675 137.986 307.029 137.986C307.383 137.986 307.67 138.273 307.67 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 138.627C324.343 138.981 324.055 139.268 323.701 139.268C323.347 139.268 323.06 138.981 323.06 138.627C323.06 138.273 323.347 137.986 323.701 137.986C324.055 137.986 324.343 138.273 324.343 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 138.627C341.015 138.981 340.728 139.268 340.374 139.268C340.02 139.268 339.732 138.981 339.732 138.627C339.732 138.273 340.02 137.986 340.374 137.986C340.728 137.986 341.015 138.273 341.015 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 138.627C357.687 138.981 357.4 139.268 357.046 139.268C356.692 139.268 356.405 138.981 356.405 138.627C356.405 138.273 356.692 137.986 357.046 137.986C357.4 137.986 357.687 138.273 357.687 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 138.627C374.359 138.981 374.072 139.268 373.718 139.268C373.364 139.268 373.077 138.981 373.077 138.627C373.077 138.273 373.364 137.986 373.718 137.986C374.072 137.986 374.359 138.273 374.359 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 155.299C224.309 155.653 224.022 155.94 223.668 155.94C223.313 155.94 223.026 155.653 223.026 155.299C223.026 154.945 223.313 154.657 223.668 154.657C224.022 154.657 224.309 154.945 224.309 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 155.299C240.981 155.653 240.694 155.94 240.34 155.94C239.986 155.94 239.699 155.653 239.699 155.299C239.699 154.945 239.986 154.657 240.34 154.657C240.694 154.657 240.981 154.945 240.981 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 155.299C257.653 155.653 257.366 155.94 257.012 155.94C256.658 155.94 256.371 155.653 256.371 155.299C256.371 154.945 256.658 154.657 257.012 154.657C257.366 154.657 257.653 154.945 257.653 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 155.299C274.326 155.653 274.039 155.94 273.684 155.94C273.33 155.94 273.043 155.653 273.043 155.299C273.043 154.945 273.33 154.657 273.684 154.657C274.039 154.657 274.326 154.945 274.326 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 155.299C290.998 155.653 290.711 155.94 290.357 155.94C290.003 155.94 289.716 155.653 289.716 155.299C289.716 154.945 290.003 154.657 290.357 154.657C290.711 154.657 290.998 154.945 290.998 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 155.299C307.67 155.653 307.383 155.94 307.029 155.94C306.675 155.94 306.388 155.653 306.388 155.299C306.388 154.945 306.675 154.657 307.029 154.657C307.383 154.657 307.67 154.945 307.67 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 155.299C324.343 155.653 324.055 155.94 323.701 155.94C323.347 155.94 323.06 155.653 323.06 155.299C323.06 154.945 323.347 154.657 323.701 154.657C324.055 154.657 324.343 154.945 324.343 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 155.299C341.015 155.653 340.728 155.94 340.374 155.94C340.02 155.94 339.732 155.653 339.732 155.299C339.732 154.945 340.02 154.657 340.374 154.657C340.728 154.657 341.015 154.945 341.015 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 155.299C357.687 155.653 357.4 155.94 357.046 155.94C356.692 155.94 356.405 155.653 356.405 155.299C356.405 154.945 356.692 154.657 357.046 154.657C357.4 154.657 357.687 154.945 357.687 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 155.299C374.359 155.653 374.072 155.94 373.718 155.94C373.364 155.94 373.077 155.653 373.077 155.299C373.077 154.945 373.364 154.657 373.718 154.657C374.072 154.657 374.359 154.945 374.359 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 171.971C224.309 172.325 224.022 172.613 223.668 172.613C223.313 172.613 223.026 172.325 223.026 171.971C223.026 171.617 223.313 171.33 223.668 171.33C224.022 171.33 224.309 171.617 224.309 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 171.971C240.981 172.325 240.694 172.613 240.34 172.613C239.986 172.613 239.699 172.325 239.699 171.971C239.699 171.617 239.986 171.33 240.34 171.33C240.694 171.33 240.981 171.617 240.981 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 171.971C257.653 172.325 257.366 172.613 257.012 172.613C256.658 172.613 256.371 172.325 256.371 171.971C256.371 171.617 256.658 171.33 257.012 171.33C257.366 171.33 257.653 171.617 257.653 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 171.971C274.326 172.325 274.039 172.613 273.684 172.613C273.33 172.613 273.043 172.325 273.043 171.971C273.043 171.617 273.33 171.33 273.684 171.33C274.039 171.33 274.326 171.617 274.326 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 171.971C290.998 172.325 290.711 172.613 290.357 172.613C290.003 172.613 289.716 172.325 289.716 171.971C289.716 171.617 290.003 171.33 290.357 171.33C290.711 171.33 290.998 171.617 290.998 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 171.971C307.67 172.325 307.383 172.613 307.029 172.613C306.675 172.613 306.388 172.325 306.388 171.971C306.388 171.617 306.675 171.33 307.029 171.33C307.383 171.33 307.67 171.617 307.67 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 171.971C324.343 172.325 324.055 172.613 323.701 172.613C323.347 172.613 323.06 172.325 323.06 171.971C323.06 171.617 323.347 171.33 323.701 171.33C324.055 171.33 324.343 171.617 324.343 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 171.971C341.015 172.325 340.728 172.613 340.374 172.613C340.02 172.613 339.732 172.325 339.732 171.971C339.732 171.617 340.02 171.33 340.374 171.33C340.728 171.33 341.015 171.617 341.015 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 171.971C357.687 172.325 357.4 172.613 357.046 172.613C356.692 172.613 356.405 172.325 356.405 171.971C356.405 171.617 356.692 171.33 357.046 171.33C357.4 171.33 357.687 171.617 357.687 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 171.971C374.359 172.325 374.072 172.613 373.718 172.613C373.364 172.613 373.077 172.325 373.077 171.971C373.077 171.617 373.364 171.33 373.718 171.33C374.072 171.33 374.359 171.617 374.359 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 188.643C224.309 188.997 224.022 189.285 223.668 189.285C223.313 189.285 223.026 188.997 223.026 188.643C223.026 188.289 223.313 188.002 223.668 188.002C224.022 188.002 224.309 188.289 224.309 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 188.643C240.981 188.997 240.694 189.285 240.34 189.285C239.986 189.285 239.699 188.997 239.699 188.643C239.699 188.289 239.986 188.002 240.34 188.002C240.694 188.002 240.981 188.289 240.981 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 188.643C257.653 188.997 257.366 189.285 257.012 189.285C256.658 189.285 256.371 188.997 256.371 188.643C256.371 188.289 256.658 188.002 257.012 188.002C257.366 188.002 257.653 188.289 257.653 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 188.643C274.326 188.997 274.039 189.285 273.684 189.285C273.33 189.285 273.043 188.997 273.043 188.643C273.043 188.289 273.33 188.002 273.684 188.002C274.039 188.002 274.326 188.289 274.326 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 188.643C290.998 188.997 290.711 189.285 290.357 189.285C290.003 189.285 289.716 188.997 289.716 188.643C289.716 188.289 290.003 188.002 290.357 188.002C290.711 188.002 290.998 188.289 290.998 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 188.643C307.67 188.997 307.383 189.285 307.029 189.285C306.675 189.285 306.388 188.997 306.388 188.643C306.388 188.289 306.675 188.002 307.029 188.002C307.383 188.002 307.67 188.289 307.67 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 188.643C324.343 188.997 324.055 189.285 323.701 189.285C323.347 189.285 323.06 188.997 323.06 188.643C323.06 188.289 323.347 188.002 323.701 188.002C324.055 188.002 324.343 188.289 324.343 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 188.643C341.015 188.997 340.728 189.285 340.374 189.285C340.02 189.285 339.732 188.997 339.732 188.643C339.732 188.289 340.02 188.002 340.374 188.002C340.728 188.002 341.015 188.289 341.015 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 188.643C357.687 188.997 357.4 189.285 357.046 189.285C356.692 189.285 356.405 188.997 356.405 188.643C356.405 188.289 356.692 188.002 357.046 188.002C357.4 188.002 357.687 188.289 357.687 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 188.643C374.359 188.997 374.072 189.285 373.718 189.285C373.364 189.285 373.077 188.997 373.077 188.643C373.077 188.289 373.364 188.002 373.718 188.002C374.072 188.002 374.359 188.289 374.359 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 205.316C224.309 205.67 224.022 205.957 223.668 205.957C223.313 205.957 223.026 205.67 223.026 205.316C223.026 204.962 223.313 204.675 223.668 204.675C224.022 204.675 224.309 204.962 224.309 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 205.316C240.981 205.67 240.694 205.957 240.34 205.957C239.986 205.957 239.699 205.67 239.699 205.316C239.699 204.962 239.986 204.675 240.34 204.675C240.694 204.675 240.981 204.962 240.981 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 205.316C257.653 205.67 257.366 205.957 257.012 205.957C256.658 205.957 256.371 205.67 256.371 205.316C256.371 204.962 256.658 204.675 257.012 204.675C257.366 204.675 257.653 204.962 257.653 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 205.316C274.326 205.67 274.039 205.957 273.684 205.957C273.33 205.957 273.043 205.67 273.043 205.316C273.043 204.962 273.33 204.675 273.684 204.675C274.039 204.675 274.326 204.962 274.326 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 205.316C290.998 205.67 290.711 205.957 290.357 205.957C290.003 205.957 289.716 205.67 289.716 205.316C289.716 204.962 290.003 204.675 290.357 204.675C290.711 204.675 290.998 204.962 290.998 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 205.316C307.67 205.67 307.383 205.957 307.029 205.957C306.675 205.957 306.388 205.67 306.388 205.316C306.388 204.962 306.675 204.675 307.029 204.675C307.383 204.675 307.67 204.962 307.67 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 205.316C324.343 205.67 324.055 205.957 323.701 205.957C323.347 205.957 323.06 205.67 323.06 205.316C323.06 204.962 323.347 204.675 323.701 204.675C324.055 204.675 324.343 204.962 324.343 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 205.316C341.015 205.67 340.728 205.957 340.374 205.957C340.02 205.957 339.732 205.67 339.732 205.316C339.732 204.962 340.02 204.675 340.374 204.675C340.728 204.675 341.015 204.962 341.015 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 205.316C357.687 205.67 357.4 205.957 357.046 205.957C356.692 205.957 356.405 205.67 356.405 205.316C356.405 204.962 356.692 204.675 357.046 204.675C357.4 204.675 357.687 204.962 357.687 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 205.316C374.359 205.67 374.072 205.957 373.718 205.957C373.364 205.957 373.077 205.67 373.077 205.316C373.077 204.962 373.364 204.675 373.718 204.675C374.072 204.675 374.359 204.962 374.359 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 221.988C224.309 222.342 224.022 222.629 223.668 222.629C223.313 222.629 223.026 222.342 223.026 221.988C223.026 221.634 223.313 221.347 223.668 221.347C224.022 221.347 224.309 221.634 224.309 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 221.988C240.981 222.342 240.694 222.629 240.34 222.629C239.986 222.629 239.699 222.342 239.699 221.988C239.699 221.634 239.986 221.347 240.34 221.347C240.694 221.347 240.981 221.634 240.981 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 221.988C257.653 222.342 257.366 222.629 257.012 222.629C256.658 222.629 256.371 222.342 256.371 221.988C256.371 221.634 256.658 221.347 257.012 221.347C257.366 221.347 257.653 221.634 257.653 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 221.988C274.326 222.342 274.039 222.629 273.684 222.629C273.33 222.629 273.043 222.342 273.043 221.988C273.043 221.634 273.33 221.347 273.684 221.347C274.039 221.347 274.326 221.634 274.326 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 221.988C290.998 222.342 290.711 222.629 290.357 222.629C290.003 222.629 289.716 222.342 289.716 221.988C289.716 221.634 290.003 221.347 290.357 221.347C290.711 221.347 290.998 221.634 290.998 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 221.988C307.67 222.342 307.383 222.629 307.029 222.629C306.675 222.629 306.388 222.342 306.388 221.988C306.388 221.634 306.675 221.347 307.029 221.347C307.383 221.347 307.67 221.634 307.67 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 221.988C324.343 222.342 324.055 222.629 323.701 222.629C323.347 222.629 323.06 222.342 323.06 221.988C323.06 221.634 323.347 221.347 323.701 221.347C324.055 221.347 324.343 221.634 324.343 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 221.988C341.015 222.342 340.728 222.629 340.374 222.629C340.02 222.629 339.732 222.342 339.732 221.988C339.732 221.634 340.02 221.347 340.374 221.347C340.728 221.347 341.015 221.634 341.015 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 221.988C357.687 222.342 357.4 222.629 357.046 222.629C356.692 222.629 356.405 222.342 356.405 221.988C356.405 221.634 356.692 221.347 357.046 221.347C357.4 221.347 357.687 221.634 357.687 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 221.988C374.359 222.342 374.072 222.629 373.718 222.629C373.364 222.629 373.077 222.342 373.077 221.988C373.077 221.634 373.364 221.347 373.718 221.347C374.072 221.347 374.359 221.634 374.359 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 238.66C224.309 239.014 224.022 239.302 223.668 239.302C223.313 239.302 223.026 239.014 223.026 238.66C223.026 238.306 223.313 238.019 223.668 238.019C224.022 238.019 224.309 238.306 224.309 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 238.66C240.981 239.014 240.694 239.302 240.34 239.302C239.986 239.302 239.699 239.014 239.699 238.66C239.699 238.306 239.986 238.019 240.34 238.019C240.694 238.019 240.981 238.306 240.981 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 238.66C257.653 239.014 257.366 239.302 257.012 239.302C256.658 239.302 256.371 239.014 256.371 238.66C256.371 238.306 256.658 238.019 257.012 238.019C257.366 238.019 257.653 238.306 257.653 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 238.66C274.326 239.014 274.039 239.302 273.684 239.302C273.33 239.302 273.043 239.014 273.043 238.66C273.043 238.306 273.33 238.019 273.684 238.019C274.039 238.019 274.326 238.306 274.326 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 238.66C290.998 239.014 290.711 239.302 290.357 239.302C290.003 239.302 289.716 239.014 289.716 238.66C289.716 238.306 290.003 238.019 290.357 238.019C290.711 238.019 290.998 238.306 290.998 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 238.66C307.67 239.014 307.383 239.302 307.029 239.302C306.675 239.302 306.388 239.014 306.388 238.66C306.388 238.306 306.675 238.019 307.029 238.019C307.383 238.019 307.67 238.306 307.67 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 238.66C324.343 239.014 324.055 239.302 323.701 239.302C323.347 239.302 323.06 239.014 323.06 238.66C323.06 238.306 323.347 238.019 323.701 238.019C324.055 238.019 324.343 238.306 324.343 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 238.66C341.015 239.014 340.728 239.302 340.374 239.302C340.02 239.302 339.732 239.014 339.732 238.66C339.732 238.306 340.02 238.019 340.374 238.019C340.728 238.019 341.015 238.306 341.015 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 238.66C357.687 239.014 357.4 239.302 357.046 239.302C356.692 239.302 356.405 239.014 356.405 238.66C356.405 238.306 356.692 238.019 357.046 238.019C357.4 238.019 357.687 238.306 357.687 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 238.66C374.359 239.014 374.072 239.302 373.718 239.302C373.364 239.302 373.077 239.014 373.077 238.66C373.077 238.306 373.364 238.019 373.718 238.019C374.072 238.019 374.359 238.306 374.359 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.309 255.333C224.309 255.687 224.022 255.974 223.668 255.974C223.313 255.974 223.026 255.687 223.026 255.333C223.026 254.979 223.313 254.691 223.668 254.691C224.022 254.691 224.309 254.979 224.309 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.981 255.333C240.981 255.687 240.694 255.974 240.34 255.974C239.986 255.974 239.699 255.687 239.699 255.333C239.699 254.979 239.986 254.691 240.34 254.691C240.694 254.691 240.981 254.979 240.981 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.653 255.333C257.653 255.687 257.366 255.974 257.012 255.974C256.658 255.974 256.371 255.687 256.371 255.333C256.371 254.979 256.658 254.691 257.012 254.691C257.366 254.691 257.653 254.979 257.653 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.326 255.333C274.326 255.687 274.039 255.974 273.684 255.974C273.33 255.974 273.043 255.687 273.043 255.333C273.043 254.979 273.33 254.691 273.684 254.691C274.039 254.691 274.326 254.979 274.326 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.998 255.333C290.998 255.687 290.711 255.974 290.357 255.974C290.003 255.974 289.716 255.687 289.716 255.333C289.716 254.979 290.003 254.691 290.357 254.691C290.711 254.691 290.998 254.979 290.998 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67 255.333C307.67 255.687 307.383 255.974 307.029 255.974C306.675 255.974 306.388 255.687 306.388 255.333C306.388 254.979 306.675 254.691 307.029 254.691C307.383 254.691 307.67 254.979 307.67 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.343 255.333C324.343 255.687 324.055 255.974 323.701 255.974C323.347 255.974 323.06 255.687 323.06 255.333C323.06 254.979 323.347 254.691 323.701 254.691C324.055 254.691 324.343 254.979 324.343 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.015 255.333C341.015 255.687 340.728 255.974 340.374 255.974C340.02 255.974 339.732 255.687 339.732 255.333C339.732 254.979 340.02 254.691 340.374 254.691C340.728 254.691 341.015 254.979 341.015 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.687 255.333C357.687 255.687 357.4 255.974 357.046 255.974C356.692 255.974 356.405 255.687 356.405 255.333C356.405 254.979 356.692 254.691 357.046 254.691C357.4 254.691 357.687 254.979 357.687 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.359 255.333C374.359 255.687 374.072 255.974 373.718 255.974C373.364 255.974 373.077 255.687 373.077 255.333C373.077 254.979 373.364 254.691 373.718 254.691C374.072 254.691 374.359 254.979 374.359 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 38.5929C539.8 38.947 540.087 39.2341 540.441 39.2341C540.795 39.2341 541.082 38.947 541.082 38.5929C541.082 38.2388 540.795 37.9517 540.441 37.9517C540.087 37.9517 539.8 38.2388 539.8 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 38.5929C523.127 38.947 523.415 39.2341 523.769 39.2341C524.123 39.2341 524.41 38.947 524.41 38.5929C524.41 38.2388 524.123 37.9517 523.769 37.9517C523.415 37.9517 523.127 38.2388 523.127 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 38.5929C506.455 38.947 506.742 39.2341 507.096 39.2341C507.45 39.2341 507.738 38.947 507.738 38.5929C507.738 38.2388 507.45 37.9517 507.096 37.9517C506.742 37.9517 506.455 38.2388 506.455 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 38.5929C489.783 38.947 490.07 39.2341 490.424 39.2341C490.778 39.2341 491.065 38.947 491.065 38.5929C491.065 38.2388 490.778 37.9517 490.424 37.9517C490.07 37.9517 489.783 38.2388 489.783 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 38.5929C473.111 38.947 473.398 39.2341 473.752 39.2341C474.106 39.2341 474.393 38.947 474.393 38.5929C474.393 38.2388 474.106 37.9517 473.752 37.9517C473.398 37.9517 473.111 38.2388 473.111 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 38.5929C456.438 38.947 456.726 39.2341 457.079 39.2341C457.433 39.2341 457.721 38.947 457.721 38.5929C457.721 38.2388 457.433 37.9517 457.079 37.9517C456.726 37.9517 456.438 38.2388 456.438 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 38.5929C439.766 38.947 440.053 39.2341 440.407 39.2341C440.761 39.2341 441.049 38.947 441.049 38.5929C441.049 38.2388 440.761 37.9517 440.407 37.9517C440.053 37.9517 439.766 38.2388 439.766 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 38.5929C423.094 38.947 423.381 39.2341 423.735 39.2341C424.089 39.2341 424.376 38.947 424.376 38.5929C424.376 38.2388 424.089 37.9517 423.735 37.9517C423.381 37.9517 423.094 38.2388 423.094 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 38.5929C406.421 38.947 406.709 39.2341 407.063 39.2341C407.417 39.2341 407.704 38.947 407.704 38.5929C407.704 38.2388 407.417 37.9517 407.063 37.9517C406.709 37.9517 406.421 38.2388 406.421 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 38.5929C389.749 38.947 390.036 39.2341 390.39 39.2341C390.744 39.2341 391.032 38.947 391.032 38.5929C391.032 38.2388 390.744 37.9517 390.39 37.9517C390.036 37.9517 389.749 38.2388 389.749 38.5929Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 55.265C539.8 55.6191 540.087 55.9063 540.441 55.9063C540.795 55.9063 541.082 55.6191 541.082 55.265C541.082 54.9109 540.795 54.6238 540.441 54.6238C540.087 54.6238 539.8 54.9109 539.8 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 55.265C523.127 55.6191 523.415 55.9063 523.769 55.9063C524.123 55.9063 524.41 55.6191 524.41 55.265C524.41 54.9109 524.123 54.6238 523.769 54.6238C523.415 54.6238 523.127 54.9109 523.127 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 55.265C506.455 55.6191 506.742 55.9063 507.096 55.9063C507.45 55.9063 507.738 55.6191 507.738 55.265C507.738 54.9109 507.45 54.6238 507.096 54.6238C506.742 54.6238 506.455 54.9109 506.455 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 55.265C489.783 55.6191 490.07 55.9063 490.424 55.9063C490.778 55.9063 491.065 55.6191 491.065 55.265C491.065 54.9109 490.778 54.6238 490.424 54.6238C490.07 54.6238 489.783 54.9109 489.783 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 55.265C473.111 55.6191 473.398 55.9063 473.752 55.9063C474.106 55.9063 474.393 55.6191 474.393 55.265C474.393 54.9109 474.106 54.6238 473.752 54.6238C473.398 54.6238 473.111 54.9109 473.111 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 55.265C456.438 55.6191 456.726 55.9063 457.079 55.9063C457.433 55.9063 457.721 55.6191 457.721 55.265C457.721 54.9109 457.433 54.6238 457.079 54.6238C456.726 54.6238 456.438 54.9109 456.438 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 55.265C439.766 55.6191 440.053 55.9063 440.407 55.9063C440.761 55.9063 441.049 55.6191 441.049 55.265C441.049 54.9109 440.761 54.6238 440.407 54.6238C440.053 54.6238 439.766 54.9109 439.766 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 55.265C423.094 55.6191 423.381 55.9063 423.735 55.9063C424.089 55.9063 424.376 55.6191 424.376 55.265C424.376 54.9109 424.089 54.6238 423.735 54.6238C423.381 54.6238 423.094 54.9109 423.094 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 55.265C406.421 55.6191 406.709 55.9063 407.063 55.9063C407.417 55.9063 407.704 55.6191 407.704 55.265C407.704 54.9109 407.417 54.6238 407.063 54.6238C406.709 54.6238 406.421 54.9109 406.421 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 55.265C389.749 55.6191 390.036 55.9063 390.39 55.9063C390.744 55.9063 391.032 55.6191 391.032 55.265C391.032 54.9109 390.744 54.6238 390.39 54.6238C390.036 54.6238 389.749 54.9109 389.749 55.265Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 71.9376C539.8 72.2917 540.087 72.5789 540.441 72.5789C540.795 72.5789 541.082 72.2917 541.082 71.9376C541.082 71.5835 540.795 71.2964 540.441 71.2964C540.087 71.2964 539.8 71.5835 539.8 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 71.9376C523.127 72.2917 523.415 72.5789 523.769 72.5789C524.123 72.5789 524.41 72.2917 524.41 71.9376C524.41 71.5835 524.123 71.2964 523.769 71.2964C523.415 71.2964 523.127 71.5835 523.127 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 71.9376C506.455 72.2917 506.742 72.5789 507.096 72.5789C507.45 72.5789 507.738 72.2917 507.738 71.9376C507.738 71.5835 507.45 71.2964 507.096 71.2964C506.742 71.2964 506.455 71.5835 506.455 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 71.9376C489.783 72.2917 490.07 72.5789 490.424 72.5789C490.778 72.5789 491.065 72.2917 491.065 71.9376C491.065 71.5835 490.778 71.2964 490.424 71.2964C490.07 71.2964 489.783 71.5835 489.783 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 71.9376C473.111 72.2917 473.398 72.5789 473.752 72.5789C474.106 72.5789 474.393 72.2917 474.393 71.9376C474.393 71.5835 474.106 71.2964 473.752 71.2964C473.398 71.2964 473.111 71.5835 473.111 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 71.9376C456.438 72.2917 456.726 72.5789 457.079 72.5789C457.433 72.5789 457.721 72.2917 457.721 71.9376C457.721 71.5835 457.433 71.2964 457.079 71.2964C456.726 71.2964 456.438 71.5835 456.438 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 71.9376C439.766 72.2917 440.053 72.5789 440.407 72.5789C440.761 72.5789 441.049 72.2917 441.049 71.9376C441.049 71.5835 440.761 71.2964 440.407 71.2964C440.053 71.2964 439.766 71.5835 439.766 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 71.9376C423.094 72.2917 423.381 72.5789 423.735 72.5789C424.089 72.5789 424.376 72.2917 424.376 71.9376C424.376 71.5835 424.089 71.2964 423.735 71.2964C423.381 71.2964 423.094 71.5835 423.094 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 71.9376C406.421 72.2917 406.709 72.5789 407.063 72.5789C407.417 72.5789 407.704 72.2917 407.704 71.9376C407.704 71.5835 407.417 71.2964 407.063 71.2964C406.709 71.2964 406.421 71.5835 406.421 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 71.9376C389.749 72.2917 390.036 72.5789 390.39 72.5789C390.744 72.5789 391.032 72.2917 391.032 71.9376C391.032 71.5835 390.744 71.2964 390.39 71.2964C390.036 71.2964 389.749 71.5835 389.749 71.9376Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 88.6095C539.8 88.9636 540.087 89.2507 540.441 89.2507C540.795 89.2507 541.082 88.9636 541.082 88.6095C541.082 88.2554 540.795 87.9683 540.441 87.9683C540.087 87.9683 539.8 88.2554 539.8 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 88.6095C523.127 88.9636 523.415 89.2507 523.769 89.2507C524.123 89.2507 524.41 88.9636 524.41 88.6095C524.41 88.2554 524.123 87.9683 523.769 87.9683C523.415 87.9683 523.127 88.2554 523.127 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 88.6095C506.455 88.9636 506.742 89.2507 507.096 89.2507C507.45 89.2507 507.738 88.9636 507.738 88.6095C507.738 88.2554 507.45 87.9683 507.096 87.9683C506.742 87.9683 506.455 88.2554 506.455 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 88.6095C489.783 88.9636 490.07 89.2507 490.424 89.2507C490.778 89.2507 491.065 88.9636 491.065 88.6095C491.065 88.2554 490.778 87.9683 490.424 87.9683C490.07 87.9683 489.783 88.2554 489.783 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 88.6095C473.111 88.9636 473.398 89.2507 473.752 89.2507C474.106 89.2507 474.393 88.9636 474.393 88.6095C474.393 88.2554 474.106 87.9683 473.752 87.9683C473.398 87.9683 473.111 88.2554 473.111 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 88.6095C456.438 88.9636 456.726 89.2507 457.079 89.2507C457.433 89.2507 457.721 88.9636 457.721 88.6095C457.721 88.2554 457.433 87.9683 457.079 87.9683C456.726 87.9683 456.438 88.2554 456.438 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 88.6095C439.766 88.9636 440.053 89.2507 440.407 89.2507C440.761 89.2507 441.049 88.9636 441.049 88.6095C441.049 88.2554 440.761 87.9683 440.407 87.9683C440.053 87.9683 439.766 88.2554 439.766 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 88.6095C423.094 88.9636 423.381 89.2507 423.735 89.2507C424.089 89.2507 424.376 88.9636 424.376 88.6095C424.376 88.2554 424.089 87.9683 423.735 87.9683C423.381 87.9683 423.094 88.2554 423.094 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 88.6095C406.421 88.9636 406.709 89.2507 407.063 89.2507C407.417 89.2507 407.704 88.9636 407.704 88.6095C407.704 88.2554 407.417 87.9683 407.063 87.9683C406.709 87.9683 406.421 88.2554 406.421 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 88.6095C389.749 88.9636 390.036 89.2507 390.39 89.2507C390.744 89.2507 391.032 88.9636 391.032 88.6095C391.032 88.2554 390.744 87.9683 390.39 87.9683C390.036 87.9683 389.749 88.2554 389.749 88.6095Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 105.282C539.8 105.636 540.087 105.923 540.441 105.923C540.795 105.923 541.082 105.636 541.082 105.282C541.082 104.928 540.795 104.641 540.441 104.641C540.087 104.641 539.8 104.928 539.8 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 105.282C523.127 105.636 523.415 105.923 523.769 105.923C524.123 105.923 524.41 105.636 524.41 105.282C524.41 104.928 524.123 104.641 523.769 104.641C523.415 104.641 523.127 104.928 523.127 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 105.282C506.455 105.636 506.742 105.923 507.096 105.923C507.45 105.923 507.738 105.636 507.738 105.282C507.738 104.928 507.45 104.641 507.096 104.641C506.742 104.641 506.455 104.928 506.455 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 105.282C489.783 105.636 490.07 105.923 490.424 105.923C490.778 105.923 491.065 105.636 491.065 105.282C491.065 104.928 490.778 104.641 490.424 104.641C490.07 104.641 489.783 104.928 489.783 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 105.282C473.111 105.636 473.398 105.923 473.752 105.923C474.106 105.923 474.393 105.636 474.393 105.282C474.393 104.928 474.106 104.641 473.752 104.641C473.398 104.641 473.111 104.928 473.111 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 105.282C456.438 105.636 456.726 105.923 457.079 105.923C457.433 105.923 457.721 105.636 457.721 105.282C457.721 104.928 457.433 104.641 457.079 104.641C456.726 104.641 456.438 104.928 456.438 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 105.282C439.766 105.636 440.053 105.923 440.407 105.923C440.761 105.923 441.049 105.636 441.049 105.282C441.049 104.928 440.761 104.641 440.407 104.641C440.053 104.641 439.766 104.928 439.766 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 105.282C423.094 105.636 423.381 105.923 423.735 105.923C424.089 105.923 424.376 105.636 424.376 105.282C424.376 104.928 424.089 104.641 423.735 104.641C423.381 104.641 423.094 104.928 423.094 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 105.282C406.421 105.636 406.709 105.923 407.063 105.923C407.417 105.923 407.704 105.636 407.704 105.282C407.704 104.928 407.417 104.641 407.063 104.641C406.709 104.641 406.421 104.928 406.421 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 105.282C389.749 105.636 390.036 105.923 390.39 105.923C390.744 105.923 391.032 105.636 391.032 105.282C391.032 104.928 390.744 104.641 390.39 104.641C390.036 104.641 389.749 104.928 389.749 105.282Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 121.954C539.8 122.309 540.087 122.596 540.441 122.596C540.795 122.596 541.082 122.309 541.082 121.954C541.082 121.6 540.795 121.313 540.441 121.313C540.087 121.313 539.8 121.6 539.8 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 121.954C523.127 122.309 523.415 122.596 523.769 122.596C524.123 122.596 524.41 122.309 524.41 121.954C524.41 121.6 524.123 121.313 523.769 121.313C523.415 121.313 523.127 121.6 523.127 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 121.954C506.455 122.309 506.742 122.596 507.096 122.596C507.45 122.596 507.738 122.309 507.738 121.954C507.738 121.6 507.45 121.313 507.096 121.313C506.742 121.313 506.455 121.6 506.455 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 121.954C489.783 122.309 490.07 122.596 490.424 122.596C490.778 122.596 491.065 122.309 491.065 121.954C491.065 121.6 490.778 121.313 490.424 121.313C490.07 121.313 489.783 121.6 489.783 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 121.954C473.111 122.309 473.398 122.596 473.752 122.596C474.106 122.596 474.393 122.309 474.393 121.954C474.393 121.6 474.106 121.313 473.752 121.313C473.398 121.313 473.111 121.6 473.111 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 121.954C456.438 122.309 456.726 122.596 457.079 122.596C457.433 122.596 457.721 122.309 457.721 121.954C457.721 121.6 457.433 121.313 457.079 121.313C456.726 121.313 456.438 121.6 456.438 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 121.954C439.766 122.309 440.053 122.596 440.407 122.596C440.761 122.596 441.049 122.309 441.049 121.954C441.049 121.6 440.761 121.313 440.407 121.313C440.053 121.313 439.766 121.6 439.766 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 121.954C423.094 122.309 423.381 122.596 423.735 122.596C424.089 122.596 424.376 122.309 424.376 121.954C424.376 121.6 424.089 121.313 423.735 121.313C423.381 121.313 423.094 121.6 423.094 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 121.954C406.421 122.309 406.709 122.596 407.063 122.596C407.417 122.596 407.704 122.309 407.704 121.954C407.704 121.6 407.417 121.313 407.063 121.313C406.709 121.313 406.421 121.6 406.421 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 121.954C389.749 122.309 390.036 122.596 390.39 122.596C390.744 122.596 391.032 122.309 391.032 121.954C391.032 121.6 390.744 121.313 390.39 121.313C390.036 121.313 389.749 121.6 389.749 121.954Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 138.627C539.8 138.981 540.087 139.268 540.441 139.268C540.795 139.268 541.082 138.981 541.082 138.627C541.082 138.273 540.795 137.986 540.441 137.986C540.087 137.986 539.8 138.273 539.8 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 138.627C523.127 138.981 523.415 139.268 523.769 139.268C524.123 139.268 524.41 138.981 524.41 138.627C524.41 138.273 524.123 137.986 523.769 137.986C523.415 137.986 523.127 138.273 523.127 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 138.627C506.455 138.981 506.742 139.268 507.096 139.268C507.45 139.268 507.738 138.981 507.738 138.627C507.738 138.273 507.45 137.986 507.096 137.986C506.742 137.986 506.455 138.273 506.455 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 138.627C489.783 138.981 490.07 139.268 490.424 139.268C490.778 139.268 491.065 138.981 491.065 138.627C491.065 138.273 490.778 137.986 490.424 137.986C490.07 137.986 489.783 138.273 489.783 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 138.627C473.111 138.981 473.398 139.268 473.752 139.268C474.106 139.268 474.393 138.981 474.393 138.627C474.393 138.273 474.106 137.986 473.752 137.986C473.398 137.986 473.111 138.273 473.111 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 138.627C456.438 138.981 456.726 139.268 457.079 139.268C457.433 139.268 457.721 138.981 457.721 138.627C457.721 138.273 457.433 137.986 457.079 137.986C456.726 137.986 456.438 138.273 456.438 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 138.627C439.766 138.981 440.053 139.268 440.407 139.268C440.761 139.268 441.049 138.981 441.049 138.627C441.049 138.273 440.761 137.986 440.407 137.986C440.053 137.986 439.766 138.273 439.766 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 138.627C423.094 138.981 423.381 139.268 423.735 139.268C424.089 139.268 424.376 138.981 424.376 138.627C424.376 138.273 424.089 137.986 423.735 137.986C423.381 137.986 423.094 138.273 423.094 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 138.627C406.421 138.981 406.709 139.268 407.063 139.268C407.417 139.268 407.704 138.981 407.704 138.627C407.704 138.273 407.417 137.986 407.063 137.986C406.709 137.986 406.421 138.273 406.421 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 138.627C389.749 138.981 390.036 139.268 390.39 139.268C390.744 139.268 391.032 138.981 391.032 138.627C391.032 138.273 390.744 137.986 390.39 137.986C390.036 137.986 389.749 138.273 389.749 138.627Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 155.299C539.8 155.653 540.087 155.94 540.441 155.94C540.795 155.94 541.082 155.653 541.082 155.299C541.082 154.945 540.795 154.657 540.441 154.657C540.087 154.657 539.8 154.945 539.8 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 155.299C523.127 155.653 523.415 155.94 523.769 155.94C524.123 155.94 524.41 155.653 524.41 155.299C524.41 154.945 524.123 154.657 523.769 154.657C523.415 154.657 523.127 154.945 523.127 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 155.299C506.455 155.653 506.742 155.94 507.096 155.94C507.45 155.94 507.738 155.653 507.738 155.299C507.738 154.945 507.45 154.657 507.096 154.657C506.742 154.657 506.455 154.945 506.455 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 155.299C489.783 155.653 490.07 155.94 490.424 155.94C490.778 155.94 491.065 155.653 491.065 155.299C491.065 154.945 490.778 154.657 490.424 154.657C490.07 154.657 489.783 154.945 489.783 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 155.299C473.111 155.653 473.398 155.94 473.752 155.94C474.106 155.94 474.393 155.653 474.393 155.299C474.393 154.945 474.106 154.657 473.752 154.657C473.398 154.657 473.111 154.945 473.111 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 155.299C456.438 155.653 456.726 155.94 457.079 155.94C457.433 155.94 457.721 155.653 457.721 155.299C457.721 154.945 457.433 154.657 457.079 154.657C456.726 154.657 456.438 154.945 456.438 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 155.299C439.766 155.653 440.053 155.94 440.407 155.94C440.761 155.94 441.049 155.653 441.049 155.299C441.049 154.945 440.761 154.657 440.407 154.657C440.053 154.657 439.766 154.945 439.766 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 155.299C423.094 155.653 423.381 155.94 423.735 155.94C424.089 155.94 424.376 155.653 424.376 155.299C424.376 154.945 424.089 154.657 423.735 154.657C423.381 154.657 423.094 154.945 423.094 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 155.299C406.421 155.653 406.709 155.94 407.063 155.94C407.417 155.94 407.704 155.653 407.704 155.299C407.704 154.945 407.417 154.657 407.063 154.657C406.709 154.657 406.421 154.945 406.421 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 155.299C389.749 155.653 390.036 155.94 390.39 155.94C390.744 155.94 391.032 155.653 391.032 155.299C391.032 154.945 390.744 154.657 390.39 154.657C390.036 154.657 389.749 154.945 389.749 155.299Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 171.971C539.8 172.325 540.087 172.613 540.441 172.613C540.795 172.613 541.082 172.325 541.082 171.971C541.082 171.617 540.795 171.33 540.441 171.33C540.087 171.33 539.8 171.617 539.8 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 171.971C523.127 172.325 523.415 172.613 523.769 172.613C524.123 172.613 524.41 172.325 524.41 171.971C524.41 171.617 524.123 171.33 523.769 171.33C523.415 171.33 523.127 171.617 523.127 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 171.971C506.455 172.325 506.742 172.613 507.096 172.613C507.45 172.613 507.738 172.325 507.738 171.971C507.738 171.617 507.45 171.33 507.096 171.33C506.742 171.33 506.455 171.617 506.455 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 171.971C489.783 172.325 490.07 172.613 490.424 172.613C490.778 172.613 491.065 172.325 491.065 171.971C491.065 171.617 490.778 171.33 490.424 171.33C490.07 171.33 489.783 171.617 489.783 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 171.971C473.111 172.325 473.398 172.613 473.752 172.613C474.106 172.613 474.393 172.325 474.393 171.971C474.393 171.617 474.106 171.33 473.752 171.33C473.398 171.33 473.111 171.617 473.111 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 171.971C456.438 172.325 456.726 172.613 457.079 172.613C457.433 172.613 457.721 172.325 457.721 171.971C457.721 171.617 457.433 171.33 457.079 171.33C456.726 171.33 456.438 171.617 456.438 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 171.971C439.766 172.325 440.053 172.613 440.407 172.613C440.761 172.613 441.049 172.325 441.049 171.971C441.049 171.617 440.761 171.33 440.407 171.33C440.053 171.33 439.766 171.617 439.766 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 171.971C423.094 172.325 423.381 172.613 423.735 172.613C424.089 172.613 424.376 172.325 424.376 171.971C424.376 171.617 424.089 171.33 423.735 171.33C423.381 171.33 423.094 171.617 423.094 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 171.971C406.421 172.325 406.709 172.613 407.063 172.613C407.417 172.613 407.704 172.325 407.704 171.971C407.704 171.617 407.417 171.33 407.063 171.33C406.709 171.33 406.421 171.617 406.421 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 171.971C389.749 172.325 390.036 172.613 390.39 172.613C390.744 172.613 391.032 172.325 391.032 171.971C391.032 171.617 390.744 171.33 390.39 171.33C390.036 171.33 389.749 171.617 389.749 171.971Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 188.643C539.8 188.997 540.087 189.285 540.441 189.285C540.795 189.285 541.082 188.997 541.082 188.643C541.082 188.289 540.795 188.002 540.441 188.002C540.087 188.002 539.8 188.289 539.8 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 188.643C523.127 188.997 523.415 189.285 523.769 189.285C524.123 189.285 524.41 188.997 524.41 188.643C524.41 188.289 524.123 188.002 523.769 188.002C523.415 188.002 523.127 188.289 523.127 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 188.643C506.455 188.997 506.742 189.285 507.096 189.285C507.45 189.285 507.738 188.997 507.738 188.643C507.738 188.289 507.45 188.002 507.096 188.002C506.742 188.002 506.455 188.289 506.455 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 188.643C489.783 188.997 490.07 189.285 490.424 189.285C490.778 189.285 491.065 188.997 491.065 188.643C491.065 188.289 490.778 188.002 490.424 188.002C490.07 188.002 489.783 188.289 489.783 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 188.643C473.111 188.997 473.398 189.285 473.752 189.285C474.106 189.285 474.393 188.997 474.393 188.643C474.393 188.289 474.106 188.002 473.752 188.002C473.398 188.002 473.111 188.289 473.111 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 188.643C456.438 188.997 456.726 189.285 457.079 189.285C457.433 189.285 457.721 188.997 457.721 188.643C457.721 188.289 457.433 188.002 457.079 188.002C456.726 188.002 456.438 188.289 456.438 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 188.643C439.766 188.997 440.053 189.285 440.407 189.285C440.761 189.285 441.049 188.997 441.049 188.643C441.049 188.289 440.761 188.002 440.407 188.002C440.053 188.002 439.766 188.289 439.766 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 188.643C423.094 188.997 423.381 189.285 423.735 189.285C424.089 189.285 424.376 188.997 424.376 188.643C424.376 188.289 424.089 188.002 423.735 188.002C423.381 188.002 423.094 188.289 423.094 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 188.643C406.421 188.997 406.709 189.285 407.063 189.285C407.417 189.285 407.704 188.997 407.704 188.643C407.704 188.289 407.417 188.002 407.063 188.002C406.709 188.002 406.421 188.289 406.421 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 188.643C389.749 188.997 390.036 189.285 390.39 189.285C390.744 189.285 391.032 188.997 391.032 188.643C391.032 188.289 390.744 188.002 390.39 188.002C390.036 188.002 389.749 188.289 389.749 188.643Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 205.316C539.8 205.67 540.087 205.957 540.441 205.957C540.795 205.957 541.082 205.67 541.082 205.316C541.082 204.962 540.795 204.675 540.441 204.675C540.087 204.675 539.8 204.962 539.8 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 205.316C523.127 205.67 523.415 205.957 523.769 205.957C524.123 205.957 524.41 205.67 524.41 205.316C524.41 204.962 524.123 204.675 523.769 204.675C523.415 204.675 523.127 204.962 523.127 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 205.316C506.455 205.67 506.742 205.957 507.096 205.957C507.45 205.957 507.738 205.67 507.738 205.316C507.738 204.962 507.45 204.675 507.096 204.675C506.742 204.675 506.455 204.962 506.455 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 205.316C489.783 205.67 490.07 205.957 490.424 205.957C490.778 205.957 491.065 205.67 491.065 205.316C491.065 204.962 490.778 204.675 490.424 204.675C490.07 204.675 489.783 204.962 489.783 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 205.316C473.111 205.67 473.398 205.957 473.752 205.957C474.106 205.957 474.393 205.67 474.393 205.316C474.393 204.962 474.106 204.675 473.752 204.675C473.398 204.675 473.111 204.962 473.111 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 205.316C456.438 205.67 456.726 205.957 457.079 205.957C457.433 205.957 457.721 205.67 457.721 205.316C457.721 204.962 457.433 204.675 457.079 204.675C456.726 204.675 456.438 204.962 456.438 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 205.316C439.766 205.67 440.053 205.957 440.407 205.957C440.761 205.957 441.049 205.67 441.049 205.316C441.049 204.962 440.761 204.675 440.407 204.675C440.053 204.675 439.766 204.962 439.766 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 205.316C423.094 205.67 423.381 205.957 423.735 205.957C424.089 205.957 424.376 205.67 424.376 205.316C424.376 204.962 424.089 204.675 423.735 204.675C423.381 204.675 423.094 204.962 423.094 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 205.316C406.421 205.67 406.709 205.957 407.063 205.957C407.417 205.957 407.704 205.67 407.704 205.316C407.704 204.962 407.417 204.675 407.063 204.675C406.709 204.675 406.421 204.962 406.421 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 205.316C389.749 205.67 390.036 205.957 390.39 205.957C390.744 205.957 391.032 205.67 391.032 205.316C391.032 204.962 390.744 204.675 390.39 204.675C390.036 204.675 389.749 204.962 389.749 205.316Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 221.988C539.8 222.342 540.087 222.629 540.441 222.629C540.795 222.629 541.082 222.342 541.082 221.988C541.082 221.634 540.795 221.347 540.441 221.347C540.087 221.347 539.8 221.634 539.8 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 221.988C523.127 222.342 523.415 222.629 523.769 222.629C524.123 222.629 524.41 222.342 524.41 221.988C524.41 221.634 524.123 221.347 523.769 221.347C523.415 221.347 523.127 221.634 523.127 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 221.988C506.455 222.342 506.742 222.629 507.096 222.629C507.45 222.629 507.738 222.342 507.738 221.988C507.738 221.634 507.45 221.347 507.096 221.347C506.742 221.347 506.455 221.634 506.455 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 221.988C489.783 222.342 490.07 222.629 490.424 222.629C490.778 222.629 491.065 222.342 491.065 221.988C491.065 221.634 490.778 221.347 490.424 221.347C490.07 221.347 489.783 221.634 489.783 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 221.988C473.111 222.342 473.398 222.629 473.752 222.629C474.106 222.629 474.393 222.342 474.393 221.988C474.393 221.634 474.106 221.347 473.752 221.347C473.398 221.347 473.111 221.634 473.111 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 221.988C456.438 222.342 456.726 222.629 457.079 222.629C457.433 222.629 457.721 222.342 457.721 221.988C457.721 221.634 457.433 221.347 457.079 221.347C456.726 221.347 456.438 221.634 456.438 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 221.988C439.766 222.342 440.053 222.629 440.407 222.629C440.761 222.629 441.049 222.342 441.049 221.988C441.049 221.634 440.761 221.347 440.407 221.347C440.053 221.347 439.766 221.634 439.766 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 221.988C423.094 222.342 423.381 222.629 423.735 222.629C424.089 222.629 424.376 222.342 424.376 221.988C424.376 221.634 424.089 221.347 423.735 221.347C423.381 221.347 423.094 221.634 423.094 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 221.988C406.421 222.342 406.709 222.629 407.063 222.629C407.417 222.629 407.704 222.342 407.704 221.988C407.704 221.634 407.417 221.347 407.063 221.347C406.709 221.347 406.421 221.634 406.421 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 221.988C389.749 222.342 390.036 222.629 390.39 222.629C390.744 222.629 391.032 222.342 391.032 221.988C391.032 221.634 390.744 221.347 390.39 221.347C390.036 221.347 389.749 221.634 389.749 221.988Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 238.66C539.8 239.014 540.087 239.302 540.441 239.302C540.795 239.302 541.082 239.014 541.082 238.66C541.082 238.306 540.795 238.019 540.441 238.019C540.087 238.019 539.8 238.306 539.8 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 238.66C523.127 239.014 523.415 239.302 523.769 239.302C524.123 239.302 524.41 239.014 524.41 238.66C524.41 238.306 524.123 238.019 523.769 238.019C523.415 238.019 523.127 238.306 523.127 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 238.66C506.455 239.014 506.742 239.302 507.096 239.302C507.45 239.302 507.738 239.014 507.738 238.66C507.738 238.306 507.45 238.019 507.096 238.019C506.742 238.019 506.455 238.306 506.455 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 238.66C489.783 239.014 490.07 239.302 490.424 239.302C490.778 239.302 491.065 239.014 491.065 238.66C491.065 238.306 490.778 238.019 490.424 238.019C490.07 238.019 489.783 238.306 489.783 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 238.66C473.111 239.014 473.398 239.302 473.752 239.302C474.106 239.302 474.393 239.014 474.393 238.66C474.393 238.306 474.106 238.019 473.752 238.019C473.398 238.019 473.111 238.306 473.111 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 238.66C456.438 239.014 456.726 239.302 457.079 239.302C457.433 239.302 457.721 239.014 457.721 238.66C457.721 238.306 457.433 238.019 457.079 238.019C456.726 238.019 456.438 238.306 456.438 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 238.66C439.766 239.014 440.053 239.302 440.407 239.302C440.761 239.302 441.049 239.014 441.049 238.66C441.049 238.306 440.761 238.019 440.407 238.019C440.053 238.019 439.766 238.306 439.766 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 238.66C423.094 239.014 423.381 239.302 423.735 239.302C424.089 239.302 424.376 239.014 424.376 238.66C424.376 238.306 424.089 238.019 423.735 238.019C423.381 238.019 423.094 238.306 423.094 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 238.66C406.421 239.014 406.709 239.302 407.063 239.302C407.417 239.302 407.704 239.014 407.704 238.66C407.704 238.306 407.417 238.019 407.063 238.019C406.709 238.019 406.421 238.306 406.421 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 238.66C389.749 239.014 390.036 239.302 390.39 239.302C390.744 239.302 391.032 239.014 391.032 238.66C391.032 238.306 390.744 238.019 390.39 238.019C390.036 238.019 389.749 238.306 389.749 238.66Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.8 255.333C539.8 255.687 540.087 255.974 540.441 255.974C540.795 255.974 541.082 255.687 541.082 255.333C541.082 254.979 540.795 254.691 540.441 254.691C540.087 254.691 539.8 254.979 539.8 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.127 255.333C523.127 255.687 523.415 255.974 523.769 255.974C524.123 255.974 524.41 255.687 524.41 255.333C524.41 254.979 524.123 254.691 523.769 254.691C523.415 254.691 523.127 254.979 523.127 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.455 255.333C506.455 255.687 506.742 255.974 507.096 255.974C507.45 255.974 507.738 255.687 507.738 255.333C507.738 254.979 507.45 254.691 507.096 254.691C506.742 254.691 506.455 254.979 506.455 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.783 255.333C489.783 255.687 490.07 255.974 490.424 255.974C490.778 255.974 491.065 255.687 491.065 255.333C491.065 254.979 490.778 254.691 490.424 254.691C490.07 254.691 489.783 254.979 489.783 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.111 255.333C473.111 255.687 473.398 255.974 473.752 255.974C474.106 255.974 474.393 255.687 474.393 255.333C474.393 254.979 474.106 254.691 473.752 254.691C473.398 254.691 473.111 254.979 473.111 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.438 255.333C456.438 255.687 456.726 255.974 457.079 255.974C457.433 255.974 457.721 255.687 457.721 255.333C457.721 254.979 457.433 254.691 457.079 254.691C456.726 254.691 456.438 254.979 456.438 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 255.333C439.766 255.687 440.053 255.974 440.407 255.974C440.761 255.974 441.049 255.687 441.049 255.333C441.049 254.979 440.761 254.691 440.407 254.691C440.053 254.691 439.766 254.979 439.766 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.094 255.333C423.094 255.687 423.381 255.974 423.735 255.974C424.089 255.974 424.376 255.687 424.376 255.333C424.376 254.979 424.089 254.691 423.735 254.691C423.381 254.691 423.094 254.979 423.094 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.421 255.333C406.421 255.687 406.709 255.974 407.063 255.974C407.417 255.974 407.704 255.687 407.704 255.333C407.704 254.979 407.417 254.691 407.063 254.691C406.709 254.691 406.421 254.979 406.421 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.749 255.333C389.749 255.687 390.036 255.974 390.39 255.974C390.744 255.974 391.032 255.687 391.032 255.333C391.032 254.979 390.744 254.691 390.39 254.691C390.036 254.691 389.749 254.979 389.749 255.333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdddii_664_32116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.161,
    y: 21.8064,
    width: 156.901,
    height: 50.7888,
    rx: 10.2599,
    fill: "url(#paint0_linear_664_32116)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_664_32116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.672,
    y: 31.8108,
    width: 30.7796,
    height: 30.7796,
    rx: 15.3898,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_664_32116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_664_32116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_664_32116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.871 44.0208C243.871 43.7109 243.62 43.4597 243.31 43.4597C243 43.4597 242.749 43.7109 242.749 44.0208C242.749 45.8356 242.348 47.0142 241.613 47.7484C240.879 48.4827 239.701 48.8836 237.886 48.8836C237.576 48.8836 237.325 49.1348 237.325 49.4446C237.325 49.7545 237.576 50.0057 237.886 50.0057C239.701 50.0057 240.879 50.4066 241.613 51.1408C242.348 51.8751 242.749 53.0537 242.749 54.8685C242.749 55.1783 243 55.4296 243.31 55.4296C243.62 55.4296 243.871 55.1783 243.871 54.8685C243.871 53.0537 244.272 51.8751 245.006 51.1408C245.74 50.4066 246.919 50.0057 248.733 50.0057C249.043 50.0057 249.294 49.7545 249.294 49.4446C249.294 49.1348 249.043 48.8836 248.733 48.8836C246.919 48.8836 245.74 48.4827 245.006 47.7484C244.272 47.0142 243.871 45.8356 243.871 44.0208Z",
    fill: "url(#paint1_linear_664_32116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.512 39.5318C237.512 39.2219 237.261 38.9707 236.951 38.9707C236.641 38.9707 236.39 39.2219 236.39 39.5318C236.39 40.6972 236.132 41.4082 235.703 41.8372C235.274 42.2662 234.563 42.5243 233.397 42.5243C233.087 42.5243 232.836 42.7755 232.836 43.0853C232.836 43.3952 233.087 43.6464 233.397 43.6464C234.563 43.6464 235.274 43.9045 235.703 44.3335C236.132 44.7625 236.39 45.4735 236.39 46.6389C236.39 46.9488 236.641 47.2 236.951 47.2C237.261 47.2 237.512 46.9488 237.512 46.6389C237.512 45.4735 237.77 44.7625 238.199 44.3335C238.628 43.9045 239.339 43.6464 240.504 43.6464C240.814 43.6464 241.065 43.3952 241.065 43.0853C241.065 42.7755 240.814 42.5243 240.504 42.5243C239.339 42.5243 238.628 42.2662 238.199 41.8372C237.77 41.4082 237.512 40.6972 237.512 39.5318Z",
    fill: "url(#paint2_linear_664_32116)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M290.837 39.6519H266.174C264.811 39.6519 263.707 40.7561 263.707 42.1182C263.707 43.4803 264.811 44.5845 266.174 44.5845H290.837C292.199 44.5845 293.303 43.4803 293.303 42.1182C293.303 40.7561 292.199 39.6519 290.837 39.6519Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.966 49.8169H266.174C264.811 49.8169 263.707 50.9211 263.707 52.2832C263.707 53.6453 264.811 54.7495 266.174 54.7495H317.966C319.328 54.7495 320.432 53.6453 320.432 52.2832C320.432 50.9211 319.328 49.8169 317.966 49.8169Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdddii_664_32116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.549,
    y: 121.57,
    width: 338.29,
    height: 133.321,
    rx: 10.2599,
    fill: "url(#paint3_linear_664_32116)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_664_32116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.06,
    y: 132.453,
    width: 30.7796,
    height: 30.7796,
    rx: 15.3898,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_664_32116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_664_32116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_664_32116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.259 144.663C244.259 144.354 244.007 144.102 243.698 144.102C243.388 144.102 243.136 144.354 243.136 144.663C243.136 146.478 242.736 147.657 242.001 148.391C241.267 149.125 240.089 149.526 238.274 149.526C237.964 149.526 237.713 149.777 237.713 150.087C237.713 150.397 237.964 150.648 238.274 150.648C240.089 150.648 241.267 151.049 242.001 151.783C242.736 152.518 243.136 153.696 243.136 155.511C243.136 155.821 243.388 156.072 243.698 156.072C244.007 156.072 244.259 155.821 244.259 155.511C244.259 153.696 244.66 152.518 245.394 151.783C246.128 151.049 247.307 150.648 249.121 150.648C249.431 150.648 249.682 150.397 249.682 150.087C249.682 149.777 249.431 149.526 249.121 149.526C247.307 149.526 246.128 149.125 245.394 148.391C244.66 147.657 244.259 146.478 244.259 144.663Z",
    fill: "url(#paint4_linear_664_32116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9 140.174C237.9 139.864 237.649 139.613 237.339 139.613C237.029 139.613 236.778 139.864 236.778 140.174C236.778 141.34 236.52 142.051 236.091 142.48C235.662 142.909 234.951 143.167 233.785 143.167C233.475 143.167 233.224 143.418 233.224 143.728C233.224 144.038 233.475 144.289 233.785 144.289C234.951 144.289 235.662 144.547 236.091 144.976C236.52 145.405 236.778 146.116 236.778 147.281C236.778 147.591 237.029 147.843 237.339 147.843C237.649 147.843 237.9 147.591 237.9 147.281C237.9 146.116 238.158 145.405 238.587 144.976C239.016 144.547 239.727 144.289 240.892 144.289C241.202 144.289 241.453 144.038 241.453 143.728C241.453 143.418 241.202 143.167 240.892 143.167C239.727 143.167 239.016 142.909 238.587 142.48C238.158 142.051 237.9 141.34 237.9 140.174Z",
    fill: "url(#paint5_linear_664_32116)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M291.225 140.294H266.562C265.199 140.294 264.095 141.398 264.095 142.761C264.095 144.123 265.199 145.227 266.562 145.227H291.225C292.587 145.227 293.691 144.123 293.691 142.761C293.691 141.398 292.587 140.294 291.225 140.294Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.354 150.459H266.562C265.199 150.459 264.095 151.563 264.095 152.926C264.095 154.288 265.199 155.392 266.562 155.392H318.354C319.716 155.392 320.82 154.288 320.82 152.926C320.82 151.563 319.716 150.459 318.354 150.459Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.358 175.987H232.015C228.726 175.987 226.06 178.356 226.06 181.279V223.618C226.06 226.541 228.726 228.911 232.015 228.911H318.358C321.646 228.911 324.312 226.541 324.312 223.618V181.279C324.312 178.356 321.646 175.987 318.358 175.987Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.865 175.987H337.522C334.234 175.987 331.568 178.356 331.568 181.279V223.618C331.568 226.541 334.234 228.911 337.522 228.911H423.865C427.154 228.911 429.82 226.541 429.82 223.618V181.279C429.82 178.356 427.154 175.987 423.865 175.987Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.373 175.987H443.03C439.741 175.987 437.075 178.356 437.075 181.279V223.618C437.075 226.541 439.741 228.911 443.03 228.911H529.373C532.662 228.911 535.328 226.541 535.328 223.618V181.279C535.328 178.356 532.662 175.987 529.373 175.987Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bdddii_664_32116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.457,
    y: 49.9216,
    width: 155.994,
    height: 50.7888,
    rx: 10.2599,
    fill: "url(#paint6_linear_664_32116)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_664_32116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.968,
    y: 59.926,
    width: 30.7796,
    height: 30.7796,
    rx: 15.3898,
    fill: "#F7FDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.132 67.7671H448.469C447.107 67.7671 446.003 68.8713 446.003 70.2334C446.003 71.5955 447.107 72.6997 448.469 72.6997H473.132C474.494 72.6997 475.598 71.5955 475.598 70.2334C475.598 68.8713 474.494 67.7671 473.132 67.7671Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.262 77.9321H448.469C447.107 77.9321 446.003 79.0363 446.003 80.3984C446.003 81.7606 447.107 82.8648 448.469 82.8648H500.262C501.624 82.8648 502.728 81.7606 502.728 80.3984C502.728 79.0363 501.624 77.9321 500.262 77.9321Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdddii_664_32116",
    x: 180.382,
    y: 1.28667,
    width: 218.46,
    height: 112.348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.41242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.2599
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.3898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_32116",
    result: "effect2_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_32116",
    result: "effect3_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_32116",
    result: "effect4_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_32116",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.84745
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.6949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.320621
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_32116",
    result: "effect6_innerShadow_664_32116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_664_32116",
    x: 223.107,
    y: 30.5283,
    width: 35.9095,
    height: 35.9095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32116",
    result: "effect2_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdddii_664_32116",
    x: 180.769,
    y: 101.05,
    width: 399.849,
    height: 194.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.41242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.2599
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.3898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_32116",
    result: "effect2_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_32116",
    result: "effect3_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_32116",
    result: "effect4_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_32116",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.84745
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.6949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.320621
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_32116",
    result: "effect6_innerShadow_664_32116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_664_32116",
    x: 223.495,
    y: 131.171,
    width: 35.9095,
    height: 35.9095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32116",
    result: "effect2_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bdddii_664_32116",
    x: 362.677,
    y: 29.4019,
    width: 217.553,
    height: 112.348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.41242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.2599
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.3898
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_32116",
    result: "effect2_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_32116",
    result: "effect3_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_32116",
    result: "effect4_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_32116",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.84745
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.6949
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.320621
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_32116",
    result: "effect6_innerShadow_664_32116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_664_32116",
    x: 405.403,
    y: 58.6435,
    width: 35.9095,
    height: 35.9095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32116",
    result: "effect2_dropShadow_664_32116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_32116",
    x1: 289.612,
    y1: 21.8064,
    x2: 289.612,
    y2: 72.5952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_32116",
    x1: 241.065,
    y1: 38.971,
    x2: 244.913,
    y2: 58.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_32116",
    x1: 241.065,
    y1: 38.9707,
    x2: 244.913,
    y2: 58.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_32116",
    x1: 380.694,
    y1: 121.57,
    x2: 380.694,
    y2: 254.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_32116",
    x1: 241.453,
    y1: 139.614,
    x2: 245.3,
    y2: 159.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_32116",
    x1: 241.453,
    y1: 139.613,
    x2: 245.301,
    y2: 159.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_664_32116",
    x1: 471.454,
    y1: 49.9216,
    x2: 471.454,
    y2: 100.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227.275,
    height: 230.772,
    fill: "white",
    transform: "translate(268.417 6.2749)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 318.056,
    height: 218.022,
    fill: "white",
    transform: "translate(223.026 37.9517)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2372,
    height: 17.9548,
    fill: "white",
    transform: "translate(231.443 38.2234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2372,
    height: 17.9548,
    fill: "white",
    transform: "translate(231.443 38.2234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2372,
    height: 17.9548,
    fill: "white",
    transform: "translate(231.443 38.2234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2372,
    height: 17.9548,
    fill: "white",
    transform: "translate(231.831 138.866)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2372,
    height: 17.9548,
    fill: "white",
    transform: "translate(231.831 138.866)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_664_32116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2372,
    height: 17.9548,
    fill: "white",
    transform: "translate(231.831 138.866)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.af53ce5aa5bd2ce315647f14b9d36f07.svg";
export { ForwardRef as ReactComponent };